import { scenarios } from './scenarios.js';

export class TestLab {
  constructor({ bus, testApi }) {
    this.bus = bus;
    this.testApi = testApi;
    this.visible = false;
    this.root = this.#create();
    document.body.append(this.root);
    window.addEventListener('keydown', (event) => {
      if (event.key === 'F1') {
        event.preventDefault();
        this.toggle();
      }
    });
  }

  toggle(force) {
    this.visible = force ?? !this.visible;
    this.root.hidden = !this.visible;
    this.root.setAttribute('aria-hidden', String(!this.visible));
  }

  #create() {
    const root = document.createElement('aside');
    root.className = 'test-lab';
    root.hidden = true;
    root.setAttribute('aria-label', 'Developer Test Lab');
    root.innerHTML = `
      <div class="test-lab__header">
        <div>
          <strong>Developer Test Lab</strong>
          <small>F1 toggles this panel</small>
        </div>
        <button type="button" data-action="close">Close</button>
      </div>
      <div class="test-lab__toolbar">
        <button type="button" data-action="pause">Pause</button>
        <button type="button" data-action="resume">Resume</button>
        <button type="button" data-action="advance">Advance 60s</button>
        <button type="button" data-action="snapshot">Snapshot</button>
      </div>
      <div class="test-lab__scenarios"></div>
      <pre class="test-lab__output" aria-live="polite"></pre>
    `;

    const list = root.querySelector('.test-lab__scenarios');
    for (const scenario of scenarios) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'scenario-card';
      button.dataset.scenario = scenario.id;
      button.innerHTML = `<strong>${scenario.label}</strong><span>${scenario.description}</span>`;
      list.append(button);
    }

    root.addEventListener('click', (event) => {
      const action = event.target.closest('[data-action]')?.dataset.action;
      const scenario = event.target.closest('[data-scenario]')?.dataset.scenario;
      let result;
      if (action === 'close') this.toggle(false);
      if (action === 'pause') result = this.testApi.pause();
      if (action === 'resume') result = this.testApi.resume();
      if (action === 'advance') result = this.testApi.advanceSimulation(60);
      if (action === 'snapshot') result = this.testApi.captureSnapshot();
      if (scenario) result = this.testApi.startScenario(scenario);
      if (result) root.querySelector('.test-lab__output').textContent = JSON.stringify(result, null, 2);
    });

    return root;
  }
}
